import { Type } from "@themes/pollinator/ui/Type";
import { ClipboardCopyButton } from "@themes/pollinator/ui/ClipboardCopyButton";
import { DownloadableAssetImage } from "../DownloadableAssetImage";
import { DownloadableAssetFile } from "@themes/pollinator/ui/DownloadableAssetFile";
import { SectionHeading } from "@themes/pollinator/ui/SectionHeading";
import { WelcomeKitData } from "@platform/types/dashboard.types";

export type Props = {
  title?: string;
  description?: string;
  data?: WelcomeKitData;
  className?: string;
  /** Callback when a download button is clicked */
  onDownload?: () => void;
};

export function ProgramWelcomeKit({
  title,
  description,
  data,
  className,
  onDownload,
}: Props) {
  // Ensure data object is correctly structured
  const safeData = {
    files: Array.isArray(data?.files) ? data.files : [],
    images: Array.isArray(data?.images) ? data.images : [],
    captions: Array.isArray(data?.captions) ? data.captions : [],
    links: Array.isArray(data?.links) ? data.links : [],
  };

  // Check if we have files, images, or captions to display
  const hasFiles = safeData.files.length > 0;
  const hasImages = safeData.images.length > 0;
  const hasCaptions = safeData.captions.length > 0;

  return (
    <SectionHeading
      className={`w-full max-w-3xl ${className ?? ""}`}
      title={title}
      description={description}
    >
      <div className="flex flex-col gap-6 w-full max-w-3xl">
        {hasFiles && safeData.files.length > 0 && (
          <DownloadableAssetFile file={safeData.files[0]} onClick={onDownload} />
        )}
        {hasCaptions && safeData.captions.length > 0 && (
          <div className="p-6 rounded-md border border-brand-800 flex flex-col gap-4 md:gap-8 md:p-12">
            <Type variant="caption" className="text-brand-700">
              {safeData.captions[0].text}
            </Type>
            <div className="mt-auto">
              <ClipboardCopyButton
                textToCopy={safeData.captions[0].text}
                label="Copy caption"
              />
            </div>
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
          {hasImages &&
            safeData.images.map((image, index) => (
              <DownloadableAssetImage
                key={`image-${index}`}
                alt={image.alt}
                src={image.imageUrl}
                downloadUrl={image.downloadUrl}
                label="Download image"
                onClick={onDownload}
              />
            ))}
        </div>
      </div>
    </SectionHeading>
  );
}

export default ProgramWelcomeKit;

